import { Star } from "lucide-react";

export function StarRating({ value = 0, size = "h-4 w-4", interactive = false, onChange }) {
  return (
    <div className="flex items-center gap-0.5" role={interactive ? "radiogroup" : undefined}>
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          type="button"
          key={i}
          disabled={!interactive}
          onClick={() => interactive && onChange?.(i)}
          className={`${interactive ? "cursor-pointer transition-transform hover:scale-110" : "cursor-default"} leading-none`}
          aria-label={`${i} star${i > 1 ? "s" : ""}`}
          data-testid={interactive ? `star-${i}` : undefined}
        >
          <Star className={`${size} ${i <= Math.round(value) ? "fill-brand text-brand" : "fill-none text-ink-muted/50"}`} />
        </button>
      ))}
    </div>
  );
}
